import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.5 0C8.654 0 9.47.54 10 1.103 10.53.539 11.347 0 12.5 0c1.346 0 2.233.734 2.741 1.384a4.634 4.634 0 0 1 .697 1.268l.01.03.004.012.002.004v.003L15 3c-.954.298-.954.3-.954.3v.003a2.251 2.251 0 0 0-.08-.19 2.632 2.632 0 0 0-.3-.497C13.391 2.266 13.03 2 12.5 2c-.53 0-.892.266-1.165.616a2.632 2.632 0 0 0-.382.687V3.3l.001-.002H9.046v.004a2.288 2.288 0 0 0-.08-.19 2.635 2.635 0 0 0-.3-.497C8.391 2.266 8.028 2 7.5 2c-.53 0-.892.266-1.165.616a2.635 2.635 0 0 0-.382.687v-.002l.001-.002L5 3c-.954-.298-.954-.3-.954-.3v-.002l.002-.004.004-.011.01-.03.034-.094a4.633 4.633 0 0 1 .663-1.175C5.267.734 6.154 0 7.5 0ZM5.952 3.306l.001-.003v.003ZM2.5 5c0 4.444-1.5 8-1.5 8H0v2h16v-2h-2s-1.559-3-1.559-5H9.227c0 2 1.273 5 1.273 5H9S7.5 9.444 7.5 5h-5Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconInfrastructureFactory16 = createIcon(IconComponent);